import { request } from '../request';

const ambassadors = {
  // 获取大使列表
  getAmbassadorsList: (data) => request('/api/ambassadors', 'get', data),
  // 获取大使详情
  getAmbassadorsDetail: (data) => request(`/api/ambassadors/${data.name}`, 'get', data),
  /** Vooglam Studio 落地页报名（字段 name、social_handle 与后端约定一致时可调整） */
  submitStudioApplication: (data) =>
    request('/api/studio_submissions', 'post', data, {
      successMsg: false,
      errorMsg: true,
    }),
};
export default ambassadors;
